import _classCallCheck from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @module GraphError
 */

/**
 * @class
 * Class for GraphError
 * @NOTE: This is NOT what is returned from the Graph
 * GraphError is created from parsing JSON errors returned from the graph
 * Some fields are renamed ie, "request-id" => requestId so you can use dot notation
 */
export var GraphError =
/**
 * @public
 * @constructor
 * Creates an instance of GraphError
 * @param {number} [statusCode = -1] - The status code of the error
 * @returns An instance of GraphError
 */
function GraphError() {
  var statusCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

  _classCallCheck(this, GraphError);

  this.statusCode = statusCode;
  this.code = null;
  this.message = null;
  this.requestId = null;
  this.date = new Date();
  this.body = null;
};